import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/apps/homepage.guro.bypltt/node_modules/next/dist/client/app-dir/link.js");
